module.exports = __webpack_public_path__ + "img/dwjingyang.0f6b6a9d.png";